import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import HTag from './HTag';
import DocumentMenu from './Document/DocumentMenu';

const DocumentWrapper = styled<any, any>('li')`
    ${propStyles};
    position: relative;
    list-style: none;
`;

DocumentWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    flex: ['none', '0 0 50%'],
};

const DocumentType = styled<any, any>('div')`
    ${propStyles};
`;

DocumentType.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginX: 'sm',
    marginY: 'xs',
    paddingY: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
};

const DocumentSelector = styled<any, any>('div')`
    ${propStyles};
`;

DocumentSelector.defaultProps = {
    display: 'flex',
    margin: 'auto 0',
};

@inject('dataStore')
@observer
class Document extends Component<any, any> {
    @computed
    get documentCount() {
        return this.props.documents.length;
    }

    @computed
    get selectedCount() {
        return this.props.documents.filter(document =>
            this.props.documentSelected(document.clientCode)
        ).length;
    }

    @computed
    get title() {
        const { documentGroupName, documentTypeAliases } = this.props;
        if (
            documentGroupName &&
            documentTypeAliases &&
            documentTypeAliases[documentGroupName]
        ) {
            return documentTypeAliases[documentGroupName];
        }
        return documentGroupName;
    }

    @computed
    get selectedLabel() {
        const { selectedCount, selectedDocumentsLabel } = this.props;
        return selectedCount === 1
            ? selectedDocumentsLabel.singular
            : selectedDocumentsLabel.plural;
    }

    @computed
    get availableLabel() {
        const { documentCount, availableDocumentsLabel } = this.props;
        return documentCount === 1
            ? availableDocumentsLabel.singular
            : availableDocumentsLabel.plural;
    }

    render() {
        const { selectedCount, documentCount } = this;
        const {
            theme,
            dataStore,
            documents,
            toggleDownload,
            documentSelected,
            metricContext,
            entityDetail,
        } = this.props;

        const { isMobile } = dataStore;

        return (
            <DocumentWrapper>
                <DocumentType {...theme.DocumentType}>
                    <HTag
                        componentTheme={
                            isMobile ? 'DocumentTitleMobile' : 'DocumentTitle'
                        }
                        defaultProps={{
                            flex: '1 0 auto',
                            fontSize: 'inherit',
                            fontWeight: 'normal',
                            margin: '0 1em 0 0',
                        }}
                        level={3}
                        text={this.title}
                    />
                    <DocumentSelector
                        {...(isMobile
                            ? theme.DocumentSelectorMobile
                            : theme.DocumentSelector)}
                    >
                        <DocumentMenu
                            documents={documents}
                            selected={documentSelected}
                            onChange={toggleDownload}
                            showCount={false}
                            showCheckbox={true}
                            showSingleDocument={true}
                            showSingleDocumentLabel={true}
                            theme={{
                                ...theme,
                                ...{
                                    CheckboxLabel: {
                                        minWidth: '0',
                                    },
                                    DownloadButton:
                                        theme.DocumentCheckboxDownloadButton,
                                    DownloadCount:
                                        theme.DocumentCheckboxDownloadCount,
                                    DocumentListItem: {
                                        display: 'flex',
                                    },
                                },
                            }}
                            metricContext={`document-${metricContext}`}
                            entityWrapper={entityDetail}
                        >
                            {selectedCount > 0 ? (
                                <Translate
                                    placeholders={{
                                        selected: selectedCount,
                                        total: documentCount,
                                    }}
                                >
                                    {this.selectedLabel}
                                </Translate>
                            ) : (
                                <Translate
                                    placeholders={{ total: documentCount }}
                                >
                                    {this.availableLabel}
                                </Translate>
                            )}
                        </DocumentMenu>
                    </DocumentSelector>
                </DocumentType>
            </DocumentWrapper>
        );
    }
}

export default withTheme(Document) as any;



// WEBPACK FOOTER //
// ./src/Components/Document.tsx